var map = {
	"./kudos-1.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-1.svg",
	"./kudos-2.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-2.svg",
	"./kudos-3.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-3.svg",
	"./kudos-4.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-4.svg",
	"./kudos-5.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-5.svg",
	"./kudos-6.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-6.svg",
	"./kudos-7.svg": "./node_modules/html-loader/dist/cjs.js!./assets/images/svg/kudo/kudos-7.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/svg/kudo sync recursive !!./node_modules/html-loader/dist/cjs.js! ^\\.\\/kudos\\-.*\\.svg$";